import React from 'react';

const CustomModal = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-[#0E0E0E] rounded-2xl p-6 shadow-lg w-11/12 max-w-md">
        <p className="text-gray-400 mb-4">{message}</p>
        <div className="flex justify-end">
          <button onClick={onClose} className="mr-2 text-gray-500 rounded">Cancel</button> {/* Added rounding here */}
          <button onClick={onConfirm} className="bg-[#F1B428] text-black px-4 py-2 rounded-3xl">Continue</button>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;